<template>
  <div v-if="product && product.care && product.care.length" class="care">
    <h3 class="detail-info-title">Care</h3>
    <ul class="care-list">
      <li v-for="(care, index) of product.care" :key="index" class="care-list-item">
        {{ care }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ProductCare',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.care {
  .care-list {
    list-style-type: disc;
    margin-left: var(--space-5);
    
    .care-list-item {
      display: list-item;
    }
  }

  @media (max-width: calc($tablet-breakpoint - 1px)) {
    margin-top: var(--space-6);

    .divider {
      display: block;
      margin-top: 10px;
      margin-bottom: var(--space-6);
    }
  }
}
</style>
